import config from '@efdigital/ll-admin-v2/config/environment';
import EmberRouter from '@embroider/router';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function () {
  // Add route declarations here
  this.route('resource');
  this.route('programs', function () {
    this.route('program', { path: ':program_id' }, function () {
      this.route('cohort', { path: 'cohort/:cohort_id' }, function () {
        this.route('participants');
        this.route('arrivals');
        this.route('coaching', function () {
          this.route('coachees');
        });
        this.route('schedule', function () {
          this.route('calendar-item', {
            path: 'calendar-item/:calendar_item_id',
          });
          this.route('announcement', { path: 'announcement/:message_id' });
        });
        this.route('content', function () {
          this.route('module', { path: 'module/:module_id' }, function () {
            this.route('page', { path: 'page/:page_id' });
            this.route('quiz', { path: 'quiz/:quiz_id' });
          });
          this.route('page', { path: 'page/:page_id' });
          this.route('quiz', { path: 'quiz/:quiz_id' });
          this.route('certificate', { path: 'certificate/:quiz_id' });
          this.route('announcements');
          this.route('discussions');
        });
      });
    });
  });
  this.route('library', function () {
    this.route('clients', function () {
      this.route('client', { path: 'client/:client_id' }, function () {
        this.route('edit', function () {
          this.route('branding');
          this.route('content');
          this.route('files');
          this.route('general');
          this.route('home');
          this.route('users');
          this.route('xapi');
          this.route('lti-integrations', function () {
            this.route(
              'platform',
              { path: 'platform/:platform_id' },
              function () {
                this.route('tool');
                this.route('deployments');
              }
            );
          });
        });
      });
    });
    this.route('media-images', function () {
      this.route('edit', { path: 'edit/:media_image_id' });
      this.route('upload');
    });
    this.route('folders', function () {
      this.route('new', { path: '/new/:parent' });
      this.route('file', { path: '/file/:file_id' });
      this.route('upload');
    });
    this.route('users', function () {
      this.route('user', { path: 'user/:user_id' });
    });
  });
  this.route('coaching', function () {
    this.route('configs', function () {
      this.route('config', { path: ':coaching_config_id' });
    });
    this.route('coaches', function () {
      this.route('coach', { path: ':coach_user_id' });
    });
    this.route('sessions', function () {
      this.route('session', { path: ':session_id' });
    });
  });
  this.route('bootstrap');
});
